export const ValidationPattern = {
  any: '.*',
  token: '^[0-9]+$',
  customToken: (length) => `^[0-9]{${length}}$`,
  alphanumeric: "^[\\w\\s'.,$_-]+$",
  extendedAlphanumeric: "^[\\w\\s'.,;:?!\\[\\]{}()<>#$_-]+$",
  email: '^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\\.)+[A-Z]{2,}$',
  emailOrDot: "^\\.$|^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$",
  //phone: '^\\+[1-9]{1}[0-9]{3,14}$',
  phone: '^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$',
  password: '(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}',
};

export const isValidEmail = (email) =>
  new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i).test(email);
